"use client";
import {
  DialogContextProvider,
  DialogScopedContextProvider
} from "./DU4D3UCJ.js";
import {
  createStoreContext
} from "./HKOOKEDE.js";

// src/popover/popover-context.tsx
var ctx = createStoreContext(
  [DialogContextProvider],
  [DialogScopedContextProvider]
);
var usePopoverContext = ctx.useContext;
var usePopoverScopedContext = ctx.useScopedContext;
var usePopoverProviderContext = ctx.useProviderContext;
var PopoverContextProvider = ctx.ContextProvider;
var PopoverScopedContextProvider = ctx.ScopedContextProvider;

export {
  usePopoverContext,
  usePopoverScopedContext,
  usePopoverProviderContext,
  PopoverContextProvider,
  PopoverScopedContextProvider
};
